import React from 'react';

import { RequiredTag } from '@components/Forms/RequiredTag';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import clsx from 'clsx';

export const useManagementFormStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexColumn,
    paddingBottom: 11,
    paddingTop: '0.58rem',
  },
  label: {
    ...common.fontWeight500,
    color: theme.palette.common.black,
    paddingTop: 3,
    width: `170px !important`,
    [theme.breakpoints.down('sm')]: {
      width: `100% !important`,
    },
  },
  labelDisabled: {
    ...common.textGray400Important,
  },
  labelDestructive: {
    ...common.fontWeight700,
  },
  textInput: {
    borderColor: '#DCDEE0 !important',
    '&:focus-within': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },
}));

export interface ManagementBaseProps {
  label?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  labelDestructive?: boolean;
}

export interface ManagementLabelProps extends ManagementBaseProps {}

export const ManagementLabel: React.FC<ManagementLabelProps> = (props) => {
  const { label, disabled, required, labelDestructive } = props;

  const classes = {
    ...useCommonStyles(),
    ...useManagementFormStyles(),
  };

  return (
    <div
      className={clsx(classes.flexInline, classes.justifyBetween)}
      style={{ paddingTop: 2, position: 'relative' }}
    >
      <span
        className={clsx(
          labelDestructive && classes.labelDestructive,
          disabled && classes.labelDisabled,
        )}
      >
        {label}
      </span>
      <div style={{ position: 'absolute', right: 0 }}>{required && <RequiredTag />}</div>
    </div>
  );
};
